import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueResource from 'vue-resource';
import vSelect from 'vue-select'
import router from './router/router.js'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css';

import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import VueDatePicker from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

// Options: You can set lang by default
Vue.use(VueDatePicker, {
  lang: 'es'
});
Vue.use(VueSweetalert2);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(BootstrapVueIcons);
Vue.use(VueResource);
Vue.component('v-select', vSelect);
let html = document.getElementsByTagName("html")[0];
// let head = document.getElementsByTagName("head")[0];
// let meta = document.createElement("meta");
// meta.name = "google";
// meta.content = "notranslate";
// head.appendChild(meta);
html.lang = "es";
html.translate = undefined;
html.className = "notranslate";
document.title = "Base cirujanos";
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')